var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import AppLayout from '@/Layouts/AppLayout';
import { useForm, usePage } from '@inertiajs/react';
import { useRoute } from 'ziggy-js';
import BranchForm from "@/Pages/Branch/Partials/BranchForm";
import { Ziggy } from "@/ziggy";
export default function Dashboard(_a) {
    var team = _a.team;
    var flash = usePage().props.flash;
    var _b = useState(true), open = _b[0], setOpen = _b[1];
    var route = useRoute(Ziggy);
    var init = {};
    var form = useForm(init);
    function submit() {
        form.post(route('team.branch.store', { team: team }), {
            errorBag: 'storeBranch',
            preserveScroll: true,
        });
    }
    function close() {
        setOpen(false);
    }
    return (_jsx(AppLayout, __assign({ title: "Create branch", pageTitle: "Create branch" }, { children: _jsx("div", __assign({ className: "max-w-xl" }, { children: _jsx(BranchForm, { team: team, form: form, close: close, submit: submit }) })) })));
}
